import { useEffect, useRef } from 'react';
import {
  focusEditLink,
  focusValidationAlertHeading,
} from '../util/address-validation/addressValidationFocus';

/**
 * Takes focus to the validation alert on mount, and hands it back to the edit
 * link the view was opened from on unmount.
 *
 * PORT NOTE: addressValidationType is held in a ref so the unmount cleanup sees
 * the current value. The class read this.props at unmount; a cleanup with an
 * empty dependency array would close over the mount-time value instead.
 */
export const useAddressValidationFocus = addressValidationType => {
  const addressValidationTypeRef = useRef(addressValidationType);

  useEffect(() => {
    addressValidationTypeRef.current = addressValidationType;
  });

  useEffect(() => {
    focusValidationAlertHeading();
  }, []);

  useEffect(() => () => focusEditLink(addressValidationTypeRef.current), []);
};
